import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

export const loadingStatus = {
  error: 'error',
  idle: 'idle',
  loading: 'loading',
  success: 'success',
};

export default class VideoReportBloc {
  resourceDetail$ = new BehaviorSubject(null);
  resourceDetailLoading$ = new BehaviorSubject(loadingStatus.idle);

  constructor({ authRepository, resourceRepository, errorRepository }) {
    this.authRepository = authRepository;
    this.resourceRepository = resourceRepository;
    this.errorRepository = errorRepository;
  }

  get isFooterVisible$() {
    return this.authRepository.auth$.pipe(
      map((auth) => {
        if (!auth) return true;
        return !(auth && auth.role === 'patient');
      })
    );
  }

  async getResourceInfo(uuid, token) {
    try {
      this.resourceDetailLoading$.next(loadingStatus.idle);

      if (!uuid || !token) throw new Error('Incomplete data requested');

      this.resourceDetailLoading$.next(loadingStatus.loading);
      const result = await this.resourceRepository.getResourceInfo(uuid, token);

      const videoData = {
        thumbnail: result.thumbnail || '',
        url: result.h264Path || result.path,
      };

      this.resourceDetail$.next({ ...result, videoData });
      this.resourceDetailLoading$.next(loadingStatus.success);
    } catch (err) {
      this.resourceDetailLoading$.next(loadingStatus.error);
      this.errorRepository.error$.next({
        message: err.message || 'Could not get the video report',
        severity: 'error',
      });
    }
  }
}
